export enum ECurriculumUrls {
  CURRICULUM = 'curriculum',
  EXTENDED = 'extended',
}
